import { DomComponentHander } from "./Handler";
export class CopyOrdererToDelivery extends DomComponentHander {
    static DomContentLoaded() {
        document.querySelector('.CopyOrderer')?.addEventListener('click', () => {
            document.querySelectorAll('[name^="orderer."]').forEach(ordererInput => {
                // .で分割した後半部分で入力項目を検索
                const name = ordererInput.getAttribute('name') ?? '';
                const detailName = name.split('.');
                if (detailName.length > 1) {
                    const target = document.querySelector(`[name="delivery.${detailName[1]}"]`);
                    if (target) {
                        target.value = ordererInput.value;
                    }
                }
            });
        });
    }
}
